import { render, staticRenderFns } from "./CustomerServiceSelector.vue?vue&type=template&id=fa0308f4&scoped=true&"
import script from "./CustomerServiceSelector.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0308f4",
  null
  
)

export default component.exports